export default "__VITE_ASSET__CA3ESsbC__"